import { FanResponseDto } from '@api'
import { FormProvider, useForm } from 'react-hook-form'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { FormField } from '@/components/ui/form/form-field'
import { ListUser } from '@/modules/chatting/types.ts'

import { DialogProps } from '../types'
import { useRenameUser } from './useRenameUser'
import {
  RENAME_USER_FORM_ID,
  RenameUserFormValues,
  renameUserFormResolver,
} from './validation'

interface Props extends DialogProps {
  user: FanResponseDto | ListUser
  onSuccess?: (name: string) => void
}

export const RenameUserDialog = ({
  isOpen,
  onClose,
  user,
  onSuccess,
}: Props) => {
  const form = useForm<RenameUserFormValues>({
    resolver: renameUserFormResolver,
    defaultValues: { name: user.displayName || '' },
  })
  const onSaveChanges = (name: string) => {
    onSuccess?.(name)
    onClose()
  }
  const setDisplayName = useRenameUser({
    onSuccess: onSaveChanges,
    userId: user.id,
  })

  const onSubmit = ({ name }: RenameUserFormValues) => setDisplayName(name)

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Edit Name</Dialog.Title>
      </Dialog.Header>
      <form
        id={RENAME_USER_FORM_ID}
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <FormProvider {...form}>
          <FormField
            label="Custom Name"
            name="name"
            maxLength={100}
            placeholder="Enter name"
            className="mt-5"
            withLengthIndicator
            withEmojiPicker
          />
        </FormProvider>
      </form>
      <Dialog.ClosableFooter onClose={onClose}>
        <Button
          form={RENAME_USER_FORM_ID}
          type="submit"
          isLoading={form.formState.isSubmitting}
          disabled={!form.formState.isDirty}
        >
          Save
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
